export default __webpack_public_path__ + "static/media/tube-4-en.5208bc01.svg";